/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Indicates the field to use for sorting the data:
 *   * CALL_DATE : the call date
 *   * CALL_TYPE : the call type
 *   * CALL_STATUS : the call status
 *   * STATION_CODE : the station code
 *   * STATION_NAME : the station name
 *   * INTERVENANT_CODE : the intervenant code
 *   * PANNE : the panne string
 *   * CREATE_TICKET : the create ticket boolean
 */
export enum CallNotificationSortFieldName {
  CALL_DATE = 'CALL_DATE',
  CALL_TYPE = 'CALL_TYPE',
  CALL_STATUS = 'CALL_STATUS',
  STATION_CODE = 'STATION_CODE',
  STATION_NAME = 'STATION_NAME',
  INTERVENANT_CODE = 'INTERVENANT_CODE',
  PANNE = 'PANNE',
  CREATE_TICKET = 'CREATE_TICKET'
}
